export const routes = {
    user_module_intelligence_home: {
        path: 'intelligence/:moduleBridgeHex/home/',
        parameters: {
            moduleBridgeHex: undefined,
        }
    },
    user_module_intelligence_storedReports: {
        path: 'intelligence/:moduleBridgeHex/stored-reports/',
        parameters: {
            moduleBridgeHex: undefined,
        }
    }
}
